var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Technik")]),(!_vm.username)?_c('MyLogin'):_vm._e(),(_vm.username)?_c('div',[_c('MyEventList'),_c('MySlotForm')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }